export const INPUT_TRIALS = 10000;
export const INPUT_TRIALS_BATCH = 100;

export const RANDOM_TRIALS = 80;
export const SPECIAL_TRIALS = 10;
export const EVALUATION_CYCLES = 10000;

export const CARD_VALUE_MULTIPLIER = parseFloat(process.env.CARD_VALUE_MULTIPLIER || '1');
export const SPY_OPPONENT_COST = parseFloat(process.env.SPY_OPPONENT_COST || '1');
export const SPY_POT_COST = parseFloat(process.env.SPY_POT_COST || '1');

export const HOLE_COST = parseFloat(process.env.HOLE_COST || '1');
export const FLOP_COST = parseFloat(process.env.FLOP_COST || '3');
export const TURN_COST = parseFloat(process.env.TURN_COST || '6');
export const RIVER_COST = parseFloat(process.env.RIVER_COST || '10');
export const ALL_IN_COST = HOLE_COST + FLOP_COST + TURN_COST + RIVER_COST;

export const BASE_POT_VALUE = CARD_VALUE_MULTIPLIER * 36.55;
export const STARTING_BUDGET = ALL_IN_COST * 10;
export const MAX_HANDS = Math.ceil(STARTING_BUDGET / HOLE_COST);
export const HISTOGRAM_BIN_SIZE = 10;

export const LOG_DIM = '\x1b[2m';
export const LOG_RESET = '\x1b[0m';

const cardsData: [string, string, number][] = [
    ['2c', 'two of clubs', 2],
    ['2d', 'two of diamonds', 2],
    ['2h', 'two of hearts', 2],
    ['2s', 'two of spades', 2],
    ['3c', 'three of clubs', 3],
    ['3d', 'three of diamonds', 3],
    ['3h', 'three of hearts', 3],
    ['3s', 'three of spades', 3],
    ['4c', 'four of clubs', 4],
    ['4d', 'four of diamonds', 4],
    ['4h', 'four of hearts', 4],
    ['4s', 'four of spades', 4],
    ['5c', 'five of clubs', 5],
    ['5d', 'five of diamonds', 5],
    ['5h', 'five of hearts', 5],
    ['5s', 'five of spades', 5],
    ['6c', 'six of clubs', 6],
    ['6d', 'six of diamonds', 6],
    ['6h', 'six of hearts', 6],
    ['6s', 'six of spades', 6],
    ['7c', 'seven of clubs', 7],
    ['7d', 'seven of diamonds', 7],
    ['7h', 'seven of hearts', 7],
    ['7s', 'seven of spades', 7],
    ['8c', 'eight of clubs', 8],
    ['8d', 'eight of diamonds', 8],
    ['8h', 'eight of hearts', 8],
    ['8s', 'eight of spades', 8],
    ['9c', 'nine of clubs', 9],
    ['9d', 'nine of diamonds', 9],
    ['9h', 'nine of hearts', 9],
    ['9s', 'nine of spades', 9],
    ['tc', 'ten of clubs', 10],
    ['td', 'ten of diamonds', 10],
    ['th', 'ten of hearts', 10],
    ['ts', 'ten of spades', 10],
    ['jc', 'jack of clubs', 10],
    ['jd', 'jack of diamonds', 10],
    ['jh', 'jack of hearts', 10],
    ['js', 'jack of spades', 10],
    ['qc', 'queen of clubs', 10],
    ['qd', 'queen of diamonds', 10],
    ['qh', 'queen of hearts', 10],
    ['qs', 'queen of spades', 10],
    ['kc', 'king of clubs', 10],
    ['kd', 'king of diamonds', 10],
    ['kh', 'king of hearts', 10],
    ['ks', 'king of spades', 10],
    ['ac', 'ace of clubs', 11],
    ['ad', 'ace of diamonds', 11],
    ['ah', 'ace of hearts', 11],
    ['as', 'ace of spades', 11],
];

export const CARDS = cardsData.map(item => item[0]);
export const CARD_NAMES = Object.fromEntries(cardsData.map(item => [item[0], item[1]]));
export const CARD_VALUES = Object.fromEntries(cardsData.map(item => [item[0], item[2] * CARD_VALUE_MULTIPLIER]));
